import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import styles from "./ModalDownload.module.css";
import {
  DateTimePicker,
  HeaderModal,
  Loading,
  Toast,
} from "../../../components";
import axiosClient from "../../../services/axiosClient";
import {
  formatDB,
  formatHour,
  downloadVideo,
  downloadVideoPlayBack,
  convertStringToDate,
  isDifferenceTwoHours,
} from "../../../utils";
import ProgressBar from "../../../components/ProgressBar";
import axios from "axios";
import streamingClient from "../../../services/streamingClient";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const cx = classNames.bind(styles);
const ModalDownload = ({ showModalDl, setShowModalDl, listCamera }) => {
  const [downloadInfo, setDownloadInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [timeStart, setTimeStart] = useState();
  const [time, setTime] = useState([]);
  const [timeEnd, setTimeEnd] = useState();
  const [select, setSelect] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const CancelToken = axios.CancelToken;
  const { t } = useTranslation();
  const source = CancelToken.source();
  const handleClose = () => {
    setIsLoading(false);
  };
  const handleSelectCamera = (e, item) => {
    if (e.target.checked) {
      setSelect([...time, item]);
    } else {
      const data = time.filter(
        (it) => it?.code !== item.code || it?.camera_code === item.code
      );
      setSelect(data);
    }
  };
  const handleDown = async (item, nameCam) => {
    setMessage(t("playback.downLoading"));
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}${item.path}`,
        {
          onDownloadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            setDownloadInfo((pre) => {
              const newData = pre.map(vdItem => {
                if (vdItem?.cameraCode === item?.camera_code) {
                  return {
                    ...vdItem,
                    progress: Math.floor((loaded * 100) / total),
                    loaded,
                    total,
                    name: nameCam.name
                  }
                }
                return vdItem;
              })
              return newData
            });
          },
          cancelToken: source.token,
          responseType: "blob",
        }
      );

      await downloadVideoPlayBack(
        response,
        `${nameCam.name}-ngay-${nameCam.day_download}-tu-${nameCam?.time_start.split(":")[0]
        }h${nameCam?.time_start.split(":")[1]}-den-${nameCam?.time_end.split(":")[0]
        }h${nameCam?.time_end.split(":")[1]}`
      );
      setDownloadInfo((info) => ({
        ...info,
        completed: true,
      }));
      setMessage(t("playback.success"));
      setShowModalDl(false);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setMessage(t("playback.error"));
    }
  };
  const handleChangeTimeStart = (data, item) => {
    // // console.log(data);

    const check = time.filter((it) => it.camera_code === item.code);
    if (check.length > 0) {
      if (data) {
        if (new Date(data.target.value) > new Date(Date.now())) {
          Toast.open(
            "Lựa chọn thời gian tải video phải nhỏ hơn thời gian hiện tại",
            "info"
          );
          const change = time.map((it) => {
            if (item.code === it.camera_code) {
              return {
                ...it,
                time_start: null,
              };
            } else {
              return it;
            }
          });
          setTime(change);
        } else {
          // setTimeStart(data.target.value);
          if (
            !check[0]?.time_end ||
            new Date(data.target.value) <=
            new Date(
              convertStringToDate(
                `${check[0]?.day_download} ${check[0]?.time_end}`
              )
            )
          ) {
            if (
              isDifferenceTwoHours(
                new Date(data.target.value),
                new Date(
                  convertStringToDate(
                    `${check[0]?.day_download} ${check[0]?.time_end}`
                  )
                )
              )
            ) {
              Toast.open("Thời gian video tải xuống không quá 2h", "info");
              const change = time.map((it) => {
                if (item.code === it.camera_code) {
                  return {
                    ...it,
                    time_start: null,
                    time_end: null,
                  };
                } else {
                  return it;
                }
              });
              setTime(change);
            } else {
              // // console.log("zo");
              const change = time.map((it) => {
                if (item.code === it.camera_code) {
                  return {
                    ...it,
                    day_download: formatDB(data.target.value),
                    time_start: formatHour(data.target.value),
                  };
                } else {
                  return it;
                }
              });
              setTime(change);
            }
          } else {
            Toast.open(t("playback.choseTimeError"), "info");
            const change = time.map((it) => {
              if (item.code === it.camera_code) {
                return {
                  ...it,
                  time_start: null,
                };
              } else {
                return it;
              }
            });
            setTime(change);
          }
        }
      } else {
        const change = time.map((it) => {
          if (item.code === it.camera_code) {
            return {
              ...it,
              day_download: null,
              time_start: null,
            };
          } else {
            return it;
          }
        });
        setTime(change);
      }
    } else {
      Toast.open("Vui lòng chọn camera trước", "info");
      const change = time.map((it) => {
        if (item.code === it.camera_code) {
          return {
            ...it,
            day_download: null,
            time_start: null,
          };
        } else {
          return it;
        }
      });
      setTime(change);
    }
  };
  const handleChangeTimeEnd = (data, item) => {
    const check = time.filter((it) => it.camera_code === item.code);
    if (check.length > 0) {
      if (data) {
        if (new Date(data.target.value) > new Date(Date.now())) {
          Toast.open(
            "Lựa chọn thời tải xuống phải nhỏ hơn thời gian hiện tại",
            "info"
          );
          const change = time.map((it) => {
            if (item.code === it.camera_code) {
              return {
                ...it,
                time_end: null,
              };
            } else {
              return it;
            }
          });
          setTime(change);
        } else {
          if (
            !check[0]?.time_start ||
            new Date(data.target.value) >=
            new Date(
              convertStringToDate(
                `${check[0]?.day_download} ${check[0]?.time_start}`
              )
            )
          ) {
            if (
              !isDifferenceTwoHours(
                new Date(
                  convertStringToDate(
                    `${check[0]?.day_download} ${check[0]?.time_start}`
                  )
                ),
                new Date(data.target.value)
              )
            ) {
              const change = time.map((it) => {
                if (item.code === it.camera_code) {
                  return {
                    ...it,
                    day_download: formatDB(data.target.value),
                    time_end: formatHour(data.target.value),
                  };
                } else {
                  return it;
                }
              });
              setTime(change);
            } else {
              Toast.open("Thời gian video tải xuống không quá 2h", "info");
              const change = time.map((it) => {
                if (item.code === it.camera_code) {
                  return {
                    ...it,
                    time_end: null,
                  };
                } else {
                  return it;
                }
              });
              setTime(change);
            }
          } else {
            Toast.open(t("playback.choseTimeError"), "info");
            // // console.log("data", data);

            const change = time.map((it) => {
              if (item.code === it.camera_code) {
                return {
                  ...it,
                  time_end: null,
                };
              } else {
                return it;
              }
            });
            setTime(change);
          }
        }
      } else {
        const change = time.map((it) => {
          if (item.code === it.camera_code) {
            return {
              ...it,
              day_download: null,
              time_end: null,
            };
          } else {
            return it;
          }
        });
        setTime(change);
      }
    } else {
      Toast.open("Vui lòng chọn camera trước", "info");
      const change = time.map((it) => {
        if (item.code === it.camera_code) {
          return {
            ...it,
            day_download: null,
            time_end: null,
          };
        } else {
          return it;
        }
      });
      setTime(change);
    }
  };
  const handleDownload = async () => {
    const check = time.every((item) => item.time_start && item.time_end);
    if (time.length > 0 && check) {
      setLoading(true);
      try {
        setMessage(t("playback.getingVideo"));
        const res = await streamingClient.post(
          "/recordManagement/post-download-playback/",
          {
            list_data: { data: time },
          }
        );
        if (res.message) {
          Toast.open(t("playback.videoOverSize"), "info");
        } else {
          setIsLoading(true);
          let list = [];
          res.data.forEach((item) => {
            list.push(item);
          });
          const listInfoDownload = list?.map(item => {
            return {
              completed: false,
              cancel: false,
              index: null,
              cameraCode: item?.camera_code
            }
          })
          setDownloadInfo(listInfoDownload);
          list.forEach((item) => {
            if (item && item?.path === "no-path") {
              const nameCam = select.find((it) => it.code === item.camera_code)
                ? select.find((it) => it.code === item.camera_code).name
                : "";
              Toast.open(
                `Camera ${nameCam} ${t("playback.noVideoInTime")}`,
                "info"
              );
              setLoading(false);
              source.cancel();
              handleClose();
            } else {
              const nameCam = time?.find((it) =>
                it?.camera_code
                  ? it?.camera_code === item.camera_code
                  : item?.camera_code === it.code
              ) || "";
              handleDown(item, nameCam);
            }
          });
        }
      } catch (e) {
        Toast.open(t("playback.downloadError"), "danger");
        setShowModalDl(false);
        setLoading(false);
        source.cancel();
        handleClose();
      }
    } else {
      Toast.open(
        !timeEnd && !timeStart && select.length > 0
          ? t("playback.emptyTime")
          : t("playback.emptyCam"),
        "danger"
      );
    }
  };
  useEffect(() => {
    const data = select.map((item) => ({
      camera_code: item.code ? item.code : item.camera_code,
      day_download: item?.day_download,
      time_end: item?.time_end,
      time_start: item?.time_start,
      name: item?.name,
    }));

    setTime(data);
  }, [select]);
  // // console.log(time);

  const getValue = (item) => {
    // // console.log(item);

    const filter = time.filter((it) => it.camera_code === item.code);
    // // console.log(filter);

    return filter.length > 0
      ? {
        day_download: filter[0]?.day_download,
        time_start: filter[0]?.time_start,
        time_end: filter[0]?.time_end,
      }
      : null;
  };

  // disable những khoảng thời gian không được chọn
  const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };
  const disabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };
  const disabledDateTime = (timeStart) => {
    const startDay = new Date(timeStart).getDate();
    const now = new Date();
    const nowTime = now.getDate() === startDay ? now.getHours() : 24;
    const nowMinute = now.getDate() === startDay ? now.getMinutes() : 60;
    // // console.log({data:range(0, 24).splice(nowTime + 1, 24 - nowTime),
    //   data2: range(nowMinute, 60),});

    return {
      disabledHours: () => range(0, 24).splice(nowTime + 1, 24 - nowTime),
      // disabledMinutes: () => range(nowMinute, 60),
    };
  };
  const disabledDateTimeEnd = (cameraTime) => {
    const startTime = new Date(cameraTime);
    const startHours = startTime.getHours();
    const now = new Date();
    const nowTime = now.getHours();
    const nowMinute = now.getMinutes();

    return {
      disabledHours: () =>
        startHours
          ? range(0, 24).filter((t) => t < startHours || t >= startHours + 2)
          : range(0, 24).splice(nowTime + 1, 24 - nowTime),
      disabledMinutes: () => (startHours ? [] : range(nowMinute, 60)),
    };
  };

  const getTimeEnd = (timeStart) => {
    const startDate = new Date(timeStart);
    const date = startDate.getDate();
    const month = startDate.getMonth() + 1;
    const year = startDate.getFullYear();
    return (
      (date < 10 ? "0" + date : date) +
      "/" +
      (month < 10 ? "0" + month : month) +
      "/" +
      year
    );
  };

  return (
    <div className={cx("container")}>
      <div className={cx("content")}>
        <HeaderModal
          onClose={() => setShowModalDl(!showModalDl)}
          title={t("playback.downloadVideo")}
        />
        <div className={cx("form")}>
          {listCamera.length > 0 &&
            listCamera.map((item, index) => {
              return (
                <div key={index} className={cx("form-item")}>
                  <div className={cx("name")}>
                    <input
                      value={select.some((sl) => sl.code === item.code)}
                      type="checkbox"
                      onChange={(e) => handleSelectCamera(e, item)}
                    />
                    <p>{item.name}</p>
                  </div>
                  <div className={cx("date")}>
                    <DateTimePicker
                      onChange={(data) => handleChangeTimeStart(data, item)}
                      value={
                        getValue(item)?.day_download &&
                          getValue(item)?.time_start
                          ? `${getValue(item)?.day_download}`
                            .split("-")
                            .reverse()
                            .join("-") +
                          `T` +
                          `${getValue(item)?.time_start}`
                          : null
                      }
                      title={t("playback.start")}
                      showTime={{ defaultValue: dayjs("00:00:00", "HH:mm:ss") }}
                      disabledDate={disabledDate}
                      disabledDateTime={() =>
                        disabledDateTime(
                          `${getValue(item)?.day_download}`
                            .split("-")
                            .reverse()
                            .join("-") +
                          `T` +
                          `${getValue(item)?.time_start}`
                        )
                      }
                      format={"DD/MM/YYYY - HH:mm"}
                      placeholder={"dd/mm/yyyy - hh:mm"}
                    />
                  </div>
                  <div className={cx("date")}>
                    <DateTimePicker
                      onChange={(data) => handleChangeTimeEnd(data, item)}
                      value={
                        getValue(item)?.day_download && getValue(item)?.time_end
                          ? `${getValue(item)?.day_download}`
                            .split("-")
                            .reverse()
                            .join("-") +
                          `T` +
                          `${getValue(item)?.time_end}`
                          : null
                      }
                      title={t("playback.end")}
                      showTime={{ defaultValue: dayjs("00:00:00", "HH:mm:ss") }}
                      disabledDateTime={() =>
                        disabledDateTimeEnd(
                          `${getValue(item)?.day_download}`
                            .split("-")
                            .reverse()
                            .join("-") +
                          `T` +
                          `${getValue(item)?.time_start}`
                        )
                      }
                      format={"DD/MM/YYYY - HH:mm"}
                      placeholder={"dd/mm/yyyy - hh:mm"}
                      minDate={dayjs(
                        getTimeEnd(
                          `${getValue(item)?.day_download}`
                            .split("-")
                            .reverse()
                            .join("-")
                        ),
                        "DD/MM/YYYY"
                      )}
                      maxDate={dayjs(
                        getTimeEnd(
                          `${getValue(item)?.day_download}`
                            .split("-")
                            .reverse()
                            .join("-")
                        ),
                        "DD/MM/YYYY"
                      )}
                    />
                  </div>
                </div>
              );
            })}
        </div>
        <div className={cx("actions")}>
          <button
            onClick={() => setShowModalDl(!showModalDl)}
            className={cx("btn", "cancel")}
          >
            {t("playback.cancel")}
          </button>
          <button onClick={handleDownload} className={cx("btn", "ok")}>
            {t("playback.down")}
          </button>
        </div>
        {loading && (
          <div className={cx("loading-layer")}>
            <div className={cx("content-loading")}>
              <Loading />
              <p className={cx("message-loading")}>{message}</p>
            </div>
          </div>
        )}
      </div>
      {isLoading && (
        <ProgressBar
          data={downloadInfo}
          onClose={handleClose}
          handleCancel={source.cancel()}
        />
      )}
    </div>
  );
};

export default ModalDownload;
